export enum HalalBonusPageTab {
  Transactions = 'transactions',
  Complaints = 'complaints',
  Establishment = 'establishment',
  Statistics = 'statistics',
  Employees = 'employees',
  Clients = 'clients',
}
